import {SafeAreaView, StyleSheet, Text, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import {observer} from 'mobx-react';
import {AnalyticsScreenProps} from 'navigations/AnalyticsFlow';
import BreadCrumbsWeb from 'components/organisms/breadCrumbsWeb';
import styleSheet from './styles';

const AnalyticInfoScreen = observer((props: AnalyticsScreenProps) => {
  const styles = styleSheet(useTheme());

  const breadCrumbTitle = props.route.params.id;

  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.containerStyle}></View>
    </SafeAreaView>
  );
});

export default AnalyticInfoScreen;
